import { TestAssignmentStatus } from './constants'

const CATEGORY_NAMES: Record<number, string> = {
  1: 'Betesa',
  2: '3D Skills',
  3: '360°',
}

const STATUS_NAMES: Record<TestAssignmentStatus['status'], string> = {
  sin_enviar: 'Sin enviar',
  envio_en_curso: 'Envío en curso',
  enviada: 'Enviada',
  respondida: 'Respondida',
  iniciada: 'Iniciada',
}

export const hasAnsweredTest = (assignments?: TestAssignmentStatus[], sentFallback?: boolean): boolean => {
  if (!assignments?.length) return Boolean(sentFallback)
  return assignments.some((assignment) =>
    assignment.has_answers === true || assignment.status === 'respondida' || assignment.status === 'iniciada'
  )
}

export const formatTestStatuses = (
  assignments: TestAssignmentStatus[] | undefined,
  expectedCategories: number[],
  sentFallback?: boolean
): string => {
  if (!assignments?.length) {
    if (sentFallback) return 'Enviada'
    return expectedCategories.length === 1 && expectedCategories[0] === 3
      ? 'Sin enviar'
      : 'Estado no disponible'
  }

  const categoryCounts = new Map<number, number>()
  const statuses = assignments.map((assignment) => {
    const count = (categoryCounts.get(assignment.category_id) || 0) + 1
    categoryCounts.set(assignment.category_id, count)
    const label = CATEGORY_NAMES[assignment.category_id] || 'Prueba'
    const suffix = assignments.filter((item) => item.category_id === assignment.category_id).length > 1
      ? ` ${count}`
      : ''
    return `${label}${suffix}: ${STATUS_NAMES[assignment.status] || 'Estado no disponible'}`
  })

  expectedCategories.forEach((categoryId) => {
    if (!categoryCounts.has(categoryId)) {
      statuses.push(`${CATEGORY_NAMES[categoryId] || 'Prueba'}: Estado no disponible`)
    }
  })

  return statuses.join(' · ')
}
